import React, { Component } from 'react'
import { extendParentClass, extendBaseClass } from '../../../utils/classes'

export class Item extends Component {
  baseClass = extendParentClass.bind(this)('item')

  extend = extendBaseClass.bind(this)

  state = {
    statistic: 0,
  }

  animationTime = 3000

  interval = null

  getNewCount = (prevState) => {
    const { statistic: endStatistic } = this.props
    if (prevState.statistic === endStatistic) {
      return endStatistic
    }
    return prevState.statistic + 1
  }

  increaseStatistic = () =>
    this.setState((prevState) => {
      const { statistic } = this.state
      if (statistic === this.props.statistic) {
        clearInterval(this.interval)
      }
      return { statistic: this.getNewCount(prevState) }
    })

  handleIntersection = () => {
    this.interval = setInterval(this.increaseStatistic, 10)
  }

  handleIntersections = (intersections) =>
    this.handleIntersection(intersections[0])

  observeElement = () => {
    const observer = new IntersectionObserver(this.handleIntersections)
    const element = document.querySelector(`.${this.baseClass}`)
    observer.observe(element)
  }

  componentDidMount() {
    this.observeElement()
  }

  render() {
    const { name, symbol } = this.props
    const { statistic } = this.state
    return (
      <div className={this.baseClass}>
        <h2 className={this.extend('statistic')}>
          {statistic}
          {symbol}
        </h2>
        <span className={this.extend('name')}>{name}</span>
      </div>
    )
  }
}

export default Item
